import React, {ReactElement} from "react";
import {PageFragment} from "@/shared/PageFragment";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {DIVIDER, PD_MD, PD_XLG, PD_XLG2, SZ_SMD} from "@/shared/dimens";
import {Button, Grid, Typography} from "@mui/material";
import {UserDisplayName} from "@/shared/types";
import {ModuleCategory, MODULES} from "../../modules";
import {ProjectSelectView} from "../../../fyneai-shared/components/ProjectSelectView";

export class ProjectsFragment extends PageFragment {

  protected getTitle(): string | null | undefined {
    return "Projects";
  }

  renderContent(): ReactElement {
    return <>
      <StyledBoxColumn
        style={{
          padding: `${PD_XLG2}px ${PD_XLG}px`,
          background: this.theme.palette.background.paper,
          borderBottom: DIVIDER
        }}>
        <Typography variant={"h4"}>Hello, {UserDisplayName(this.getMemberAuth().member.user)}</Typography>
        <Typography>Welcome to FyneAI Console.</Typography>
      </StyledBoxColumn>
      <StyledBoxColumn style={{padding: PD_XLG, gap: PD_XLG}}>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Projects</Typography>
          <ProjectSelectView/>
        </StyledBoxColumn>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Quick Links</Typography>
          <Grid container style={{marginTop: -PD_MD}}>
            {MODULES.filter(module => module.category===ModuleCategory.PROJECT).map((module, index) =>
              <Grid
                key={`home-link-${index}`}
                xs={6} sm={4} md={3} lg={2}
                style={{padding: "2%"}}>
                <Button
                  href={`/${module.name}`}
                  variant="outlined"
                  style={{
                    padding: 0,
                    width: "100%",
                    // border: "4px solid " + theme.palette.secondary.main,
                    aspectRatio: 1,
                  }}>
                  <StyledBoxColumn style={{alignItems: "center", justifyContent: "center", padding: PD_MD}}>
                    <module.iconType style={{width: SZ_SMD, height: SZ_SMD}}/>
                    <Typography variant={"h6"}>{module.text}</Typography>
                  </StyledBoxColumn>
                </Button>
              </Grid>)}
          </Grid>
        </StyledBoxColumn>
      </StyledBoxColumn>
    </>;
  }
}